import styled from "styled-components"
import { hideAt } from "helpers/styled"
import Item from "./Item"

const Ul = styled.ul`
  display: block;
  list-style: none;
  margin: 0;
  padding: 0;
  ${hideAt("md")}
`

export default function List() {
  return (
    <Ul>
      <Item>
        Solo <b>1 coche</b> disponible por oferta
      </Item>
      <Item>
        Estudio online en <b>5 minutos</b>
      </Item>
      <Item>
        Pruébalo <b>15 días</b> o 1.000km
      </Item>
      <Item>
        Devuélvelo sin coste a los <b>6 meses</b>
      </Item>
      <Item>
        Si te gusta, <b>lo compras</b>
      </Item>
      <Item>
        Entrega <b>rápida</b>
      </Item>
    </Ul>
  )
}
